import 'twin.macro';
import 'styled-components/macro';

import { Link } from 'react-router-dom-v5-compat';

import { MenuItem } from './MenuItem';
import { MenuList } from './MenuList';

export interface MainMenuProps {
  title?: string;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  team?: string;
}

export const MainMenu = ({ title, shouldHideContent, shouldHideInspirationLibrary, team, ...props }: MainMenuProps) => {
  const inspirationLibraryPath = `/${team}/inspiration-library`;

  return (
    <MenuList title={title} tw="sm:mt-0 sm:flex sm:space-x-3" {...props}>
      {!shouldHideContent && (
        <Link to={`/${team}`}>
          <MenuItem>Content</MenuItem>
        </Link>
      )}
      {!shouldHideInspirationLibrary && (
        <Link to={inspirationLibraryPath}>
          <MenuItem>Inspiration Library</MenuItem>
        </Link>
      )}
    </MenuList>
  );
};
